/**
 * Literales de UI de los módulos de plataforma del admin:
 * platform-saldos-red.js, tickets.js, pozos-comunes.js,
 * platform-ficha-entidades.js y platform-ficha-dispositivos.js.
 *
 * Clave = texto español EXACTO tal como aparece en el código (estilo gettext).
 * Los literales globales (Guardar, Cancelar, Editar, Eliminar, Crear, Cerrar,
 * Buscar, Activo, Inactivo, Tipo, Estado, Fecha, Todos, Confirmar, Dispositivo,
 * Sorteo, Apuesta, Premio, Caja, Sistema, Marketing…) viven en
 * diccionario-comunes.js o diccionario-operacion.js y NO se re-declaran aquí.
 *
 * Terminología pt-BR canónica del proyecto: sorteio, aposta, caixa, saque,
 * fechamento (corte), adiantamento (adelanto), Ponto de Venda (punto de venta),
 * operador de caixa (cajero), poço (pozo).
 */

export const DICCIONARIO_PLATAFORMA = {
    // ── platform-saldos-red.js ───────────────────────────────────────────────
    'Error cargando saldos': {
        pt: 'Erro ao carregar saldos',
        en: 'Error loading balances',
        ru: 'Ошибка загрузки балансов',
    },
    'Sin resultados para': { pt: 'Sem resultados para', en: 'No results for', ru: 'Нет результатов для' },
    'No hay nodos con prepago activo': {
        pt: 'Não há nós com pré-pago ativo',
        en: 'No nodes with active prepaid',
        ru: 'Нет узлов с активной предоплатой',
    },
    'Cargar más': { pt: 'Carregar mais', en: 'Load more', ru: 'Загрузить ещё' },
    total: { pt: 'total', en: 'total', ru: 'всего' },
    'Buscar nodo por nombre...': {
        pt: 'Buscar nó por nome...',
        en: 'Search node by name...',
        ru: 'Поиск узла по имени...',
    },
    'Todos los niveles': { pt: 'Todos os níveis', en: 'All levels', ru: 'Все уровни' },
    Bloqueados: { pt: 'Bloqueados', en: 'Blocked', ru: 'Заблокированные' },
    Críticos: { pt: 'Críticos', en: 'Critical', ru: 'Критические' },
    'Saldo bajo': { pt: 'Saldo baixo', en: 'Low balance', ru: 'Низкий баланс' },
    'Pagar desde mi nodo': { pt: 'Pagar do meu nó', en: 'Pay from my node', ru: 'Оплатить с моего узла' },
    'Premios Pendientes de Cobro': {
        pt: 'Prêmios Pendentes de Recebimento',
        en: 'Prizes Pending Collection',
        ru: 'Призы, ожидающие получения',
    },
    'Tickets ganadores que no han sido cobrados. Puedes pagar desde tu nodo si el PV no tiene efectivo.': {
        pt: 'Tickets ganhadores que não foram recebidos. Você pode pagar do seu nó se o PV não tiver dinheiro.',
        en: 'Winning tickets that have not been collected. You can pay from your node if the point of sale has no cash.',
        ru: 'Выигрышные билеты, которые не были получены. Вы можете оплатить со своего узла, если у точки продаж нет наличных.',
    },
    'Recargar saldo prepago': {
        pt: 'Recarregar saldo pré-pago',
        en: 'Top up prepaid balance',
        ru: 'Пополнить предоплаченный баланс',
    },
    'Monto a recargar': { pt: 'Valor a recarregar', en: 'Top-up amount', ru: 'Сумма пополнения' },
    '¿Cómo se está haciendo este pago?': {
        pt: 'Como este pagamento está sendo feito?',
        en: 'How is this payment being made?',
        ru: 'Как осуществляется этот платёж?',
    },
    'A deuda': { pt: 'A débito', en: 'On credit', ru: 'В долг' },
    'El PV queda debiendo el monto recargado.': {
        pt: 'O PV fica devendo o valor recarregado.',
        en: 'The point of sale owes the topped-up amount.',
        ru: 'Точка продаж остаётся должна пополненную сумму.',
    },
    'PV ya pagó en efectivo': {
        pt: 'PV já pagou em dinheiro',
        en: 'Point of sale already paid in cash',
        ru: 'Точка продаж уже оплатила наличными',
    },
    'Recibís el cash en tu caja. El PV no queda debiendo.': {
        pt: 'Você recebe o dinheiro no seu caixa. O PV não fica devendo.',
        en: 'You receive the cash in your cashbox. The point of sale owes nothing.',
        ru: 'Вы получаете наличные в свою кассу. Точка продаж ничего не должна.',
    },
    'Ej: motivo de la recarga': {
        pt: 'Ex: motivo da recarga',
        en: 'E.g.: reason for the top-up',
        ru: 'Напр.: причина пополнения',
    },
    'Revisar →': { pt: 'Revisar →', en: 'Review →', ru: 'Проверить →' },
    'Moneda del PV:': { pt: 'Moeda do PV:', en: 'Point of sale currency:', ru: 'Валюта точки продаж:' },
    'Notas:': { pt: 'Notas:', en: 'Notes:', ru: 'Заметки:' },
    '⚠️ Excede el límite de crédito del PV.': {
        pt: '⚠️ Excede o limite de crédito do PV.',
        en: '⚠️ Exceeds the point of sale credit limit.',
        ru: '⚠️ Превышает кредитный лимит точки продаж.',
    },
    'Confirmo que excede el límite y quiero recargar igual': {
        pt: 'Confirmo que excede o limite e quero recarregar assim mesmo',
        en: 'I confirm it exceeds the limit and want to top up anyway',
        ru: 'Подтверждаю, что лимит превышен, и хочу пополнить всё равно',
    },
    '← Atrás': { pt: '← Voltar', en: '← Back', ru: '← Назад' },
    'recargar a deuda': { pt: 'recarregar a débito', en: 'top up on credit', ru: 'пополнить в долг' },
    'asentar cobro': { pt: 'registrar cobrança', en: 'record collection', ru: 'зарегистрировать оплату' },
    'Confirmar recarga a deuda': {
        pt: 'Confirmar recarga a débito',
        en: 'Confirm top-up on credit',
        ru: 'Подтвердить пополнение в долг',
    },
    'Confirmar cobro en efectivo': {
        pt: 'Confirmar cobrança em dinheiro',
        en: 'Confirm cash collection',
        ru: 'Подтвердить оплату наличными',
    },
    'Modal en estado inválido': {
        pt: 'Modal em estado inválido',
        en: 'Modal in invalid state',
        ru: 'Модальное окно в недопустимом состоянии',
    },
    'Ingresá un monto válido': {
        pt: 'Informe um valor válido',
        en: 'Enter a valid amount',
        ru: 'Введите корректную сумму',
    },
    'Marcá la confirmación para recargar excediendo el límite': {
        pt: 'Marque a confirmação para recarregar excedendo o limite',
        en: 'Check the confirmation to top up exceeding the limit',
        ru: 'Отметьте подтверждение, чтобы пополнить с превышением лимита',
    },
    'Procesando…': { pt: 'Processando…', en: 'Processing…', ru: 'Обработка…' },
    'Error al recargar': { pt: 'Erro ao recarregar', en: 'Error topping up', ru: 'Ошибка пополнения' },
    'Deuda subió.': { pt: 'Débito aumentou.', en: 'Debt increased.', ru: 'Долг увеличился.' },
    'Cobrado en efectivo.': { pt: 'Cobrado em dinheiro.', en: 'Collected in cash.', ru: 'Оплачено наличными.' },
    'Estado inválido': { pt: 'Estado inválido', en: 'Invalid state', ru: 'Недопустимое состояние' },
    Recargar: { pt: 'Recarregar', en: 'Top up', ru: 'Пополнить' },

    // ── tickets.js ───────────────────────────────────────────────────────────
    'Tickets Recientes': { pt: 'Tickets Recentes', en: 'Recent Tickets', ru: 'Недавние билеты' },
    'No hay tickets registrados': {
        pt: 'Não há tickets registrados',
        en: 'No tickets registered',
        ru: 'Нет зарегистрированных билетов',
    },
    'Ingrese un codigo de ticket': {
        pt: 'Informe um código de ticket',
        en: 'Enter a ticket code',
        ru: 'Введите код билета',
    },
    'Ticket no encontrado': { pt: 'Ticket não encontrado', en: 'Ticket not found', ru: 'Билет не найден' },
    'Error al buscar ticket': { pt: 'Erro ao buscar ticket', en: 'Error searching ticket', ru: 'Ошибка поиска билета' },
    'Activo (Pendiente de sorteo)': {
        pt: 'Ativo (Pendente de sorteio)',
        en: 'Active (Pending draw)',
        ru: 'Активен (ожидает розыгрыша)',
    },
    'GANADOR - Pendiente de cobro': {
        pt: 'GANHADOR - Pendente de recebimento',
        en: 'WINNER - Pending collection',
        ru: 'ВЫИГРЫШ - Ожидает получения',
    },
    Perdedor: { pt: 'Perdedor', en: 'Loser', ru: 'Проигрышный' },
    Cobrado: { pt: 'Saques', en: 'Collected', ru: 'Получено' },
    Expirado: { pt: 'Expirado', en: 'Expired', ru: 'Просрочен' },
    Anulado: { pt: 'Anulado', en: 'Voided', ru: 'Аннулирован' },
    'TICKET: ': { pt: 'TICKET: ', en: 'TICKET: ', ru: 'БИЛЕТ: ' },
    'Estado: ': { pt: 'Status: ', en: 'Status: ', ru: 'Статус: ' },
    'Caja: ': { pt: 'Caixa: ', en: 'Cashbox: ', ru: 'Касса: ' },
    'Punto de Venta: ': { pt: 'Ponto de Venda: ', en: 'Point of Sale: ', ru: 'Точка продаж: ' },
    'Sorteo: ': { pt: 'Sorteio: ', en: 'Draw: ', ru: 'Розыгрыш: ' },
    'APUESTAS:': { pt: 'APOSTAS:', en: 'BETS:', ru: 'СТАВКИ:' },
    'Monto Total: ': { pt: 'Valor Total: ', en: 'Total Amount: ', ru: 'Общая сумма: ' },
    'Premio: ': { pt: 'Prêmio: ', en: 'Prize: ', ru: 'Приз: ' },
    'Creado: ': { pt: 'Criado: ', en: 'Created: ', ru: 'Создан: ' },
    'Expira: ': { pt: 'Expira: ', en: 'Expires: ', ru: 'Истекает: ' },
    'Dispositivo / Caja': { pt: 'Dispositivo / Caixa', en: 'Device / Cashbox', ru: 'Устройство / Касса' },
    'Debe seleccionar un dispositivo': {
        pt: 'Deve selecionar um dispositivo',
        en: 'You must select a device',
        ru: 'Необходимо выбрать устройство',
    },
    'Error cargando dispositivos': {
        pt: 'Erro ao carregar dispositivos',
        en: 'Error loading devices',
        ru: 'Ошибка загрузки устройств',
    },
    'No hay cajas/dispositivos autorizados': {
        pt: 'Não há caixas/dispositivos autorizados',
        en: 'No authorized cashboxes/devices',
        ru: 'Нет авторизованных касс/устройств',
    },
    Cobrar: { pt: 'Receber', en: 'Collect', ru: 'Получить' },
    Anular: { pt: 'Anular', en: 'Void', ru: 'Аннулировать' },
    'Error al cobrar ticket': {
        pt: 'Erro ao receber ticket',
        en: 'Error collecting ticket',
        ru: 'Ошибка получения билета',
    },
    'Error al anular ticket': {
        pt: 'Erro ao anular ticket',
        en: 'Error voiding ticket',
        ru: 'Ошибка аннулирования билета',
    },
    'Motivo de anulación (opcional)': {
        pt: 'Motivo de anulação (opcional)',
        en: 'Void reason (optional)',
        ru: 'Причина аннулирования (необязательно)',
    },
    Aceptar: { pt: 'Aceitar', en: 'Accept', ru: 'Принять' },

    // ── pozos-comunes.js ─────────────────────────────────────────────────────
    'Cargando pozos...': { pt: 'Carregando poços...', en: 'Loading pools...', ru: 'Загрузка пулов...' },
    'Error al cargar pozos.': {
        pt: 'Erro ao carregar poços.',
        en: 'Error loading pools.',
        ru: 'Ошибка загрузки пулов.',
    },
    'No hay pozos comunes configurados.': {
        pt: 'Não há poços comuns configurados.',
        en: 'No common pools configured.',
        ru: 'Нет настроенных общих пулов.',
    },
    Ponderado: { pt: 'Ponderado', en: 'Weighted', ru: 'Взвешенный' },
    Uniforme: { pt: 'Uniforme', en: 'Uniform', ru: 'Равномерный' },
    Acumulado: { pt: 'Acumulado', en: 'Accumulated', ru: 'Накопленный' },
    'del umbral': { pt: 'do limite', en: 'of the threshold', ru: 'от порога' },
    Pozo: { pt: 'Poço', en: 'Pool', ru: 'Пул' },
    guardado: { pt: 'salvo', en: 'saved', ru: 'сохранён' },
    creado: { pt: 'criado', en: 'created', ru: 'создан' },
    'Editar Pozo Común': { pt: 'Editar Poço Comum', en: 'Edit Common Pool', ru: 'Редактировать общий пул' },
    'Error interno: borrador no inicializado': {
        pt: 'Erro interno: rascunho não inicializado',
        en: 'Internal error: draft not initialized',
        ru: 'Внутренняя ошибка: черновик не инициализирован',
    },
    'El nombre es obligatorio': { pt: 'O nome é obrigatório', en: 'The name is required', ru: 'Имя обязательно' },
    'Multiplicador mínimo no puede ser mayor que el máximo': {
        pt: 'O multiplicador mínimo não pode ser maior que o máximo',
        en: 'Minimum multiplier cannot be greater than the maximum',
        ru: 'Минимальный множитель не может быть больше максимального',
    },
    '¿Guardar y resetear': { pt: '¿Salvar e redefinir', en: 'Save and reset', ru: 'Сохранить и сбросить' },
    'Se guardarán los cambios, el acumulado volverá al valor base y se recalculará el umbral.': {
        pt: 'As alterações serão salvas, o acumulado voltará ao valor base e o limite será recalculado.',
        en: 'Changes will be saved, the accumulated value will return to the base value and the threshold will be recalculated.',
        ru: 'Изменения будут сохранены, накопленное значение вернётся к базовому, а порог будет пересчитан.',
    },
    '¿Eliminar el pozo': { pt: 'Excluir o poço', en: 'Delete the pool', ru: 'Удалить пул' },
    'Esta acción es irreversible.': {
        pt: 'Esta ação é irreversível.',
        en: 'This action is irreversible.',
        ru: 'Это действие необратимо.',
    },
    'Pozo guardado y reseteado': {
        pt: 'Poço salvo e redefinido',
        en: 'Pool saved and reset',
        ru: 'Пул сохранён и сброшен',
    },
    'Pozo eliminado': { pt: 'Poço excluído', en: 'Pool deleted', ru: 'Пул удалён' },
    // JACK-1A — configuración multinivel (cards + modal en modals.js)
    visible: { pt: 'visível', en: 'visible', ru: 'видимый' },
    reserva: { pt: 'reserva', en: 'reserve', ru: 'резерв' },
    de: { pt: 'de', en: 'of', ru: 'из' },
    Completar: { pt: 'Completar', en: 'Complete', ru: 'Завершить' },
    'Configuración multinivel pendiente': {
        pt: 'Configuração multinível pendente',
        en: 'Multi-level configuration pending',
        ru: 'Многоуровневая настройка не завершена',
    },
    'Configuración multinivel': {
        pt: 'Configuração multinível',
        en: 'Multi-level configuration',
        ru: 'Многоуровневая настройка',
    },
    'Cargar preset de referencia (propuesta A)': {
        pt: 'Carregar preset de referência (proposta A)',
        en: 'Load reference preset (proposal A)',
        ru: 'Загрузить эталонный пресет (вариант A)',
    },
    'Configuración multinivel pendiente. Este pozo sigue operando como hasta ahora y se pueden editar sus campos de siempre. Para completarla: elegir el nivel y el reparto del aporte, y guardar. Es la misma fila: conserva id, saldo, base, umbral, historial y suscripciones.':
        {
            pt: 'Configuração multinível pendente. Este poço continua operando como até agora e seus campos habituais podem ser editados. Para completá-la: escolher o nível e a divisão da contribuição, e salvar. É a mesma linha: conserva id, saldo, base, limite, histórico e assinaturas.',
            en: 'Multi-level configuration pending. This pool keeps operating as it does today and its usual fields can be edited. To complete it: choose the level and the contribution split, then save. Same row: id, balance, base, threshold, history and subscriptions are preserved.',
            ru: 'Многоуровневая настройка не завершена. Пул продолжает работать как прежде, обычные поля можно редактировать. Чтобы завершить: выбрать уровень и распределение взноса и сохранить. Это та же строка: id, баланс, база, порог, история и подписки сохраняются.',
        },
    'Cada pozo es exactamente un nivel de su colección. El preset rellena base, rango, aportes, estrategia y sesgo con la propuesta aprobada; no guarda nada hasta pulsar Guardar.':
        {
            pt: 'Cada poço é exatamente um nível da sua coleção. O preset preenche base, faixa, contribuições, estratégia e viés com a proposta aprovada; nada é salvo até clicar em Salvar.',
            en: 'Each pool is exactly one level of its collection. The preset fills base, range, contributions, strategy and bias with the approved proposal; nothing is saved until you press Save.',
            ru: 'Каждый пул — ровно один уровень своей коллекции. Пресет заполняет базу, диапазон, взносы, стратегию и смещение утверждённым вариантом; ничего не сохраняется до нажатия «Сохранить».',
        },
    Nivel: { pt: 'Nível', en: 'Level', ru: 'Уровень' },
    'Sin nivel (configuración pendiente)': {
        pt: 'Sem nível (configuração pendente)',
        en: 'No level (configuration pending)',
        ru: 'Без уровня (настройка не завершена)',
    },
    'Obligatorio en un pozo nuevo': {
        pt: 'Obrigatório em um poço novo',
        en: 'Required for a new pool',
        ru: 'Обязательно для нового пула',
    },
    'Estrategia de distribución del umbral': {
        pt: 'Estratégia de distribuição do limite',
        en: 'Threshold distribution strategy',
        ru: 'Стратегия распределения порога',
    },
    'Uniforme (comportamiento actual)': {
        pt: 'Uniforme (comportamento atual)',
        en: 'Uniform (current behaviour)',
        ru: 'Равномерная (текущее поведение)',
    },
    'Sesgada al techo': { pt: 'Enviesada ao teto', en: 'Skewed to the ceiling', ru: 'Смещённая к потолку' },
    '% aporte visible': { pt: '% contribuição visível', en: '% visible contribution', ru: '% видимого взноса' },
    '% aporte a reserva': { pt: '% contribuição à reserva', en: '% contribution to reserve', ru: '% взноса в резерв' },
    'Sesgo hacia el techo': { pt: 'Viés para o teto', en: 'Bias towards the ceiling', ru: 'Смещение к потолку' },
    '1 = sin sesgo. Solo aplica con la estrategia sesgada al techo.': {
        pt: '1 = sem viés. Só se aplica com a estratégia enviesada ao teto.',
        en: '1 = no bias. Only applies with the ceiling-skewed strategy.',
        ru: '1 = без смещения. Применяется только со стратегией смещения к потолку.',
    },
    'Saldo actual (solo lectura)': {
        pt: 'Saldo atual (somente leitura)',
        en: 'Current balance (read-only)',
        ru: 'Текущий баланс (только чтение)',
    },
    'Reserva actual (solo lectura)': {
        pt: 'Reserva atual (somente leitura)',
        en: 'Current reserve (read-only)',
        ru: 'Текущий резерв (только чтение)',
    },
    'Overflow actual (solo lectura)': {
        pt: 'Overflow atual (somente leitura)',
        en: 'Current overflow (read-only)',
        ru: 'Текущий перелив (только чтение)',
    },
    'Reparto del aporte:': { pt: 'Divisão da contribuição:', en: 'Contribution split:', ru: 'Распределение взноса:' },
    'El aporte visible más la reserva supera el % de aporte por defecto': {
        pt: 'A contribuição visível mais a reserva supera o % de contribuição padrão',
        en: 'Visible contribution plus reserve exceeds the default contribution %',
        ru: 'Видимый взнос плюс резерв превышают % взноса по умолчанию',
    },
    'Elegir primero el nivel para cargar su preset de referencia': {
        pt: 'Escolher primeiro o nível para carregar seu preset de referência',
        en: 'Choose the level first to load its reference preset',
        ru: 'Сначала выберите уровень, чтобы загрузить его эталонный пресет',
    },
    'Preset de referencia cargado para': {
        pt: 'Preset de referência carregado para',
        en: 'Reference preset loaded for',
        ru: 'Эталонный пресет загружен для',
    },
    'Revisar los valores y guardar si corresponde.': {
        pt: 'Revisar os valores e salvar se corresponder.',
        en: 'Review the values and save if appropriate.',
        ru: 'Проверьте значения и сохраните, если всё верно.',
    },
    'Elegir el nivel del pozo: Grand, Major, Minor o Mini': {
        pt: 'Escolher o nível do poço: Grand, Major, Minor ou Mini',
        en: 'Choose the pool level: Grand, Major, Minor or Mini',
        ru: 'Выберите уровень пула: Grand, Major, Minor или Mini',
    },
    'Para configurar el reparto, la estrategia o el sesgo, elegir primero el nivel. Si la configuración multinivel queda pendiente, dejar esos campos como están.':
        {
            pt: 'Para configurar a divisão, a estratégia ou o viés, escolher primeiro o nível. Se a configuração multinível ficar pendente, deixar esses campos como estão.',
            en: 'To configure the split, strategy or bias, choose the level first. If the multi-level configuration stays pending, leave those fields as they are.',
            ru: 'Чтобы настроить распределение, стратегию или смещение, сначала выберите уровень. Если многоуровневая настройка остаётся незавершённой, оставьте эти поля без изменений.',
        },

    // ── platform-ficha-entidades.js ──────────────────────────────────────────
    '(sin nombre)': { pt: '(sem nome)', en: '(no name)', ru: '(без имени)' },
    'Sin nodo asignado': { pt: 'Sem nó atribuído', en: 'No node assigned', ru: 'Узел не назначен' },
    'Nunca ingresó': { pt: 'Nunca acessou', en: 'Never logged in', ru: 'Никогда не входил' },
    'Miembro desde': { pt: 'Membro desde', en: 'Member since', ru: 'Участник с' },
    'Caja vinculada': { pt: 'Caixa vinculada', en: 'Linked cashbox', ru: 'Привязанная касса' },
    'Acceso total (superadmin)': {
        pt: 'Acesso total (superadmin)',
        en: 'Full access (superadmin)',
        ru: 'Полный доступ (суперадмин)',
    },
    'Sin permisos activos': { pt: 'Sem permissões ativas', en: 'No active permissions', ru: 'Нет активных разрешений' },
    // 'Clientes' ya en diccionario-comunes.js → { pt: 'Clientes' }
    // 'Finanzas' ya en diccionario-comunes.js → { pt: 'Finanças' }
    // 'Juegos' ya en diccionario-comunes.js → { pt: 'Jogos' }
    // 'Marketing' ya en diccionario-comunes.js → { pt: 'Marketing' }
    // 'Sistema' ya en diccionario-operacion.js → { pt: 'Sistema' }
    'Caja / Tickets': { pt: 'Caixa / Tickets', en: 'Cashbox / Tickets', ru: 'Касса / Билеты' },
    permiso: { pt: 'permissão', en: 'permission', ru: 'разрешение' },
    permisos: { pt: 'permissões', en: 'permissions', ru: 'разрешения' },
    personalizados: { pt: 'personalizados', en: 'custom', ru: 'персональные' },
    'Solo un superadministrador puede editar este usuario.': {
        pt: 'Somente um superadministrador pode editar este usuário.',
        en: 'Only a superadministrator can edit this user.',
        ru: 'Только суперадминистратор может редактировать этого пользователя.',
    },
    'Restablecer contraseña': { pt: 'Redefinir senha', en: 'Reset password', ru: 'Сбросить пароль' },

    // ── platform-ficha-dispositivos.js ───────────────────────────────────────
    Normal: { pt: 'Normal', en: 'Normal', ru: 'Обычный' },
    Avanzado: { pt: 'Avançado', en: 'Advanced', ru: 'Расширенный' },
    Fleet: { pt: 'Fleet', en: 'Fleet', ru: 'Fleet' },
    APK: { pt: 'APK', en: 'APK', ru: 'APK' },
    Cajeros: { pt: 'Operadores', en: 'Cashiers', ru: 'Кассиры' },
    min: { pt: 'min', en: 'min', ru: 'мин' },
    'Recarga:': { pt: 'Recarga:', en: 'Top-up:', ru: 'Пополнение:' },
    'Saldo actual:': { pt: 'Saldo atual:', en: 'Current balance:', ru: 'Текущий баланс:' },
    'Saldo proyectado:': { pt: 'Saldo projetado:', en: 'Projected balance:', ru: 'Прогнозируемый баланс:' },
    'Límite:': { pt: 'Limite:', en: 'Limit:', ru: 'Лимит:' },
    'Dispositivo ': { pt: 'Dispositivo ', en: 'Device ', ru: 'Устройство ' },
    Conexión: { pt: 'Conexão', en: 'Connection', ru: 'Соединение' },
    Offline: { pt: 'Offline', en: 'Offline', ru: 'Не в сети' },
    'Última conexión': { pt: 'Última conexão', en: 'Last connection', ru: 'Последнее соединение' },
    Pausado: { pt: 'Pausado', en: 'Paused', ru: 'Приостановлено' },
    Instalación: { pt: 'Instalação', en: 'Installation', ru: 'Установка' },
    Operativo: { pt: 'Operacional', en: 'Operational', ru: 'Работает' },
    'Sin instalar': { pt: 'Sem instalar', en: 'Not installed', ru: 'Не установлено' },
    'Legacy (sin vale)': { pt: 'Legado (sem vale)', en: 'Legacy (no voucher)', ru: 'Устаревший (без ваучера)' },
    'Generar APK (QR)': { pt: 'Gerar APK (QR)', en: 'Generate APK (QR)', ru: 'Создать APK (QR)' },
    'Sorteos asignados': { pt: 'Sorteios atribuídos', en: 'Assigned draws', ru: 'Назначенные розыгрыши' },
    // Panel de acceso INLINE de la ficha de dispositivos.
    'Acceso del dispositivo': { pt: 'Acesso do dispositivo', en: 'Device access', ru: 'Доступ к устройству' },
    'Ver QR': { pt: 'Ver QR', en: 'Show QR', ru: 'Показать QR' },
    'Copiar enlace': { pt: 'Copiar link', en: 'Copy link', ru: 'Копировать ссылку' },
    'Bajar APK': { pt: 'Baixar APK', en: 'Download APK', ru: 'Скачать APK' },
    'Generar link': { pt: 'Gerar link', en: 'Generate link', ru: 'Создать ссылку' },
    Regenerar: { pt: 'Regerar', en: 'Regenerate', ru: 'Пересоздать' },
    'Generando APK…': { pt: 'Gerando APK…', en: 'Generating APK…', ru: 'Создание APK…' },
    'Este aparato ya está instalado. Generá un APK nuevo (identidad nueva) si necesitás reinstalarlo o moverlo a otro equipo.':
        {
            pt: 'Este aparelho já está instalado. Gere um APK novo (identidade nova) se precisar reinstalá-lo ou movê-lo para outro equipamento.',
            en: 'This device is already installed. Generate a new APK (new identity) if you need to reinstall it or move it to another device.',
            ru: 'Это устройство уже установлено. Создайте новый APK (новая идентификация), если нужно переустановить его или перенести на другое устройство.',
        },
    'Generá el link de acceso para entregárselo al operador del dispositivo.': {
        pt: 'Gere o link de acesso para entregá-lo ao operador do dispositivo.',
        en: 'Generate the access link to hand it to the device operator.',
        ru: 'Создайте ссылку доступа, чтобы передать её оператору устройства.',
    },
    'Enlace copiado al portapapeles.': {
        pt: 'Link copiado para a área de transferência.',
        en: 'Link copied to clipboard.',
        ru: 'Ссылка скопирована в буфер обмена.',
    },
    'Enlace:': { pt: 'Link:', en: 'Link:', ru: 'Ссылка:' },
    'Link de acceso copiado al portapapeles.': {
        pt: 'Link de acesso copiado para a área de transferência.',
        en: 'Access link copied to clipboard.',
        ru: 'Ссылка доступа скопирована в буфер обмена.',
    },
    'Link de acceso:': { pt: 'Link de acesso:', en: 'Access link:', ru: 'Ссылка доступа:' },

    // Grupo de pozos — campo del modal y barra del listado.
    'Grupo (opcional)': { pt: 'Grupo (opcional)', en: 'Group (optional)', ru: 'Группа (необязательно)' },
    'Sin grupo': { pt: 'Sem grupo', en: 'No group', ru: 'Без группы' },
    'Ej: Lima': { pt: 'Ex: Lima', en: 'E.g. Lima', ru: 'Напр.: Лима' },
    'Junta los pozos de una colección para elegirlos de una vez. No cambia el dinero.': {
        pt: 'Junta os jackpots de uma coleção para escolhê-los de uma vez. Não altera o dinheiro.',
        en: 'Groups the pots of a collection so they can be picked at once. It does not change the money.',
        ru: 'Объединяет фонды коллекции, чтобы выбрать их разом. Деньги не меняет.',
    },

    // Crear los cuatro niveles de un grupo en un solo acto (corte 3).
    Grupo: { pt: 'Grupo', en: 'Group', ru: 'Группа' },
    'Crear los cuatro': { pt: 'Criar os quatro', en: 'Create all four', ru: 'Создать все четыре' },
    'Crear los cuatro niveles de este grupo': {
        pt: 'Criar os quatro níveis deste grupo',
        en: 'Create all four levels of this group',
        ru: 'Создать все четыре уровня этой группы',
    },
    'Escribir el nombre del grupo antes de crear sus cuatro niveles': {
        pt: 'Escrever o nome do grupo antes de criar os seus quatro níveis',
        en: 'Enter the group name before creating its four levels',
        ru: 'Введите название группы, прежде чем создавать её четыре уровня',
    },
    'pozos creados. Revisar sus valores antes de financiar la colección.': {
        pt: 'poços comuns criados. Rever os seus valores antes de financiar a coleção.',
        en: 'pots created. Review their values before financing the collection.',
        ru: 'фондов создано. Проверьте их значения перед финансированием коллекции.',
    },
    'Se crean cuatro pozos disponibles con el preset de referencia, listos para editar. No se financian ni se activa ningún producto.':
        {
            pt: 'São criados quatro poços disponíveis com o preset de referência, prontos para editar. Não são financiados nem é ativado nenhum produto.',
            en: 'Four available pots are created with the reference preset, ready to edit. They are not funded and no product is activated.',
            ru: 'Создаются четыре доступных фонда с эталонным пресетом, готовые к редактированию. Средства не вносятся, продукты не активируются.',
        },
    // ── pozos acumulados — modal de cinco apartados ──────────────────────────
    'Cargando pozos acumulados...': {
        pt: 'Carregando poços acumulados...',
        en: 'Loading accumulated pots...',
        ru: 'Загрузка накопительных фондов...',
    },
    'Error al cargar los pozos acumulados.': {
        pt: 'Erro ao carregar os poços acumulados.',
        en: 'Error loading accumulated pots.',
        ru: 'Ошибка загрузки накопительных фондов.',
    },
    'Todavía no hay pozos acumulados.': {
        pt: 'Ainda não há poços acumulados.',
        en: 'No accumulated pots yet.',
        ru: 'Накопительных фондов пока нет.',
    },
    Ponderada: { pt: 'Ponderada', en: 'Weighted', ru: 'Взвешенный' },
    'Configuración anterior': {
        pt: 'Configuração anterior',
        en: 'Previous setup',
        ru: 'Прежняя конфигурация',
    },
    'de contribución': { pt: 'de contribuição', en: 'contribution', ru: 'взноса' },
    'del disparo': { pt: 'do disparo', en: 'of trigger', ru: 'до срабатывания' },
    'Cuanto más apostó un jugador, más probabilidades tiene.': {
        pt: 'Quanto mais o jogador apostou, mais chances ele tem.',
        en: 'The more a player bet, the better their chances.',
        ru: 'Чем больше игрок поставил, тем выше его шансы.',
    },
    'Todos los participantes tienen la misma probabilidad.': {
        pt: 'Todos os participantes têm a mesma chance.',
        en: 'Every participant has the same chance.',
        ru: 'У всех участников одинаковые шансы.',
    },
    'Gana quien apostó primero en la ronda que dispara el pozo.': {
        pt: 'Ganha quem apostou primeiro na rodada que dispara o poço.',
        en: 'The first bettor in the triggering round wins.',
        ru: 'Побеждает тот, кто поставил первым в раунде срабатывания.',
    },
    'Gana quien apostó último en la ronda que dispara el pozo.': {
        pt: 'Ganha quem apostou por último na rodada que dispara o poço.',
        en: 'The last bettor in the triggering round wins.',
        ru: 'Побеждает тот, кто поставил последним в раунде срабатывания.',
    },
    'Editar pozo acumulado': {
        pt: 'Editar poço acumulado',
        en: 'Edit accumulated pot',
        ru: 'Изменить накопительный фонд',
    },
    'Nuevo pozo acumulado': {
        pt: 'Novo poço acumulado',
        en: 'New accumulated pot',
        ru: 'Новый накопительный фонд',
    },
    'Solo el propietario o un superadmin puede editar este pozo': {
        pt: 'Somente o proprietário ou um superadmin pode editar este poço',
        en: 'Only the owner or a superadmin can edit this pot',
        ru: 'Изменить этот фонд может только владелец или суперадмин',
    },
    'Mi nodo': { pt: 'Meu nó', en: 'My node', ru: 'Мой узел' },
    'Guarda lo que todavía no llega a un céntimo en vez de descartarlo en cada jugada, así una apuesta pequeña también aporta.':
        {
            pt: 'Guarda o que ainda não chega a um centavo em vez de descartar a cada jogada, assim uma aposta pequena também contribui.',
            en: 'Keeps what does not yet reach a cent instead of discarding it each play, so a small bet also contributes.',
            ru: 'Сохраняет то, что ещё не достигло копейки, вместо отбрасывания при каждой игре, поэтому и малая ставка вносит вклад.',
        },
    'No se pudo leer la política de este pozo.': {
        pt: 'Não foi possível ler a política deste poço.',
        en: 'Could not read this pot policy.',
        ru: 'Не удалось прочитать политику этого фонда.',
    },
    'Este pozo conserva las fracciones. No puede cambiarse: ya hay fracciones guardadas bajo esta política.': {
        pt: 'Este poço conserva as frações. Não pode ser alterado: já há frações guardadas sob esta política.',
        en: 'This pot keeps fractions. It cannot be changed: fractions are already stored under this policy.',
        ru: 'Этот фонд сохраняет доли. Изменить нельзя: доли уже накоплены по этой политике.',
    },
    'Este pozo descarta las fracciones. No puede cambiarse después de crear el pozo.': {
        pt: 'Este poço descarta as frações. Não pode ser alterado depois de criado.',
        en: 'This pot discards fractions. It cannot be changed after creation.',
        ru: 'Этот фонд отбрасывает доли. После создания изменить нельзя.',
    },
    'El pozo todavía no existe: se creará disponible y sin financiar.': {
        pt: 'O poço ainda não existe: será criado disponível e sem financiamento.',
        en: 'The pot does not exist yet: it will be created available and unfunded.',
        ru: 'Фонд ещё не создан: он появится доступным и без финансирования.',
    },
    'Se consultan al abrir la colección': {
        pt: 'São consultadas ao abrir a coleção',
        en: 'Checked when opening the collection',
        ru: 'Проверяются при открытии коллекции',
    },
    'Disponible para selección': {
        pt: 'Disponível para seleção',
        en: 'Available for selection',
        ru: 'Доступен для выбора',
    },
    'Saldo visible': { pt: 'Saldo visível', en: 'Visible balance', ru: 'Видимый баланс' },
    Excedente: { pt: 'Excedente', en: 'Surplus', ru: 'Излишек' },
    'Suscripciones actuales': {
        pt: 'Assinaturas atuais',
        en: 'Current subscriptions',
        ru: 'Текущие подписки',
    },
    'Conserva fracciones': { pt: 'Conserva frações', en: 'Keeps fractions', ru: 'Сохраняет доли' },
    'Sin dato': { pt: 'Sem dado', en: 'No data', ru: 'Нет данных' },
    'Se reinicia en': { pt: 'Reinicia em', en: 'Resets at', ru: 'Сбрасывается на' },
    'y puede dispararse entre': {
        pt: 'e pode disparar entre',
        en: 'and can trigger between',
        ru: 'и может сработать между',
    },
    'Con esta reserva el pozo no junta la base siguiente antes del máximo: suba el máximo o la reserva.': {
        pt: 'Com esta reserva o pote não junta a base seguinte antes do máximo: aumente o máximo ou a reserva.',
        en: 'With this reserve the jackpot cannot fund the next base before its maximum: raise the maximum or the reserve.',
        ru: 'С таким резервом джекпот не накопит следующую базу до максимума: увеличьте максимум или резерв.',
    },
    'Completar base y rango para ver el importe de disparo.': {
        pt: 'Preencha a base e a faixa para ver o valor de disparo.',
        en: 'Fill in base and range to see the trigger amount.',
        ru: 'Заполните базу и диапазон, чтобы увидеть сумму срабатывания.',
    },
    'Contribución total por apuesta': {
        pt: 'Contribuição total por aposta',
        en: 'Total contribution per bet',
        ru: 'Общий взнос со ставки',
    },
    'Parte que aumenta el pozo visible': {
        pt: 'Parte que aumenta o poço visível',
        en: 'Share that grows the visible pot',
        ru: 'Доля, увеличивающая видимый фонд',
    },
    'Parte reservada para el siguiente ciclo': {
        pt: 'Parte reservada para o próximo ciclo',
        en: 'Share reserved for the next cycle',
        ru: 'Доля в резерве на следующий цикл',
    },
    'Parte sin destino': { pt: 'Parte sem destino', en: 'Unassigned share', ru: 'Доля без назначения' },
    'Sin nivel asignado, toda la contribución aumenta el pozo visible.': {
        pt: 'Sem nível atribuído, toda a contribuição aumenta o poço visível.',
        en: 'With no level assigned, the whole contribution grows the visible pot.',
        ru: 'Без назначенного уровня весь взнос увеличивает видимый фонд.',
    },
    '¿La reserva financia el siguiente ciclo?': {
        pt: 'A reserva financia o próximo ciclo?',
        en: 'Does the reserve fund the next cycle?',
        ru: 'Резерв финансирует следующий цикл?',
    },
    'Todavía no': { pt: 'Ainda não', en: 'Not yet', ru: 'Пока нет' },
    faltan: { pt: 'faltam', en: 'missing', ru: 'не хватает' },
    'Elegir el nivel y el reparto, y guardar para completar la configuración.': {
        pt: 'Escolha o nível e a divisão e salve para completar a configuração.',
        en: 'Choose the level and the split, then save to complete the setup.',
        ru: 'Выберите уровень и распределение, затем сохраните, чтобы завершить настройку.',
    },
    'Elegir primero el nivel para cargar sus valores de referencia': {
        pt: 'Escolha primeiro o nível para carregar seus valores de referência',
        en: 'Choose the level first to load its reference values',
        ru: 'Сначала выберите уровень, чтобы загрузить эталонные значения',
    },
    'Valores de referencia cargados para': {
        pt: 'Valores de referência carregados para',
        en: 'Reference values loaded for',
        ru: 'Эталонные значения загружены для',
    },
    'Revisar y guardar si corresponde.': {
        pt: 'Revise e salve se estiver correto.',
        en: 'Review and save if correct.',
        ru: 'Проверьте и сохраните, если верно.',
    },
    'Error en': { pt: 'Erro em', en: 'Error in', ru: 'Ошибка в' },
    'El disparo mínimo no puede ser mayor que el máximo': {
        pt: 'O disparo mínimo não pode ser maior que o máximo',
        en: 'The minimum trigger cannot be greater than the maximum',
        ru: 'Минимум срабатывания не может превышать максимум',
    },
    'Para configurar el reparto o la distribución, elegir primero el nivel.': {
        pt: 'Para configurar a divisão ou a distribuição, escolha primeiro o nível.',
        en: 'To configure the split or the distribution, choose the level first.',
        ru: 'Чтобы настроить распределение, сначала выберите уровень.',
    },
    'El reparto supera la contribución total': {
        pt: 'A divisão excede a contribuição total',
        en: 'The split exceeds the total contribution',
        ru: 'Распределение превышает общий взнос',
    },
    'Para asignarle nivel, usar «Completar la configuración de niveles».': {
        pt: 'Para atribuir um nível, use «Completar a configuração de níveis».',
        en: 'To assign a level, use "Complete the level setup".',
        ru: 'Чтобы назначить уровень, используйте «Завершить настройку уровней».',
    },
    'Escribir el nombre del grupo antes de crear sus cuatro pozos': {
        pt: 'Escreva o nome do grupo antes de criar seus quatro poços',
        en: 'Enter the group name before creating its four pots',
        ru: 'Укажите имя группы перед созданием её четырёх фондов',
    },
    'pozos acumulados creados. Revisar sus valores antes de financiar la colección.': {
        pt: 'poços acumulados criados. Revise seus valores antes de financiar a coleção.',
        en: 'accumulated pots created. Review their values before funding the collection.',
        ru: 'накопительных фондов создано. Проверьте значения перед финансированием коллекции.',
    },
    'este pozo': { pt: 'este poço', en: 'this pot', ru: 'этот фонд' },
    '¿Guardar y reiniciar el acumulado de': {
        pt: 'Salvar e reiniciar o acumulado de',
        en: 'Save and reset the accumulated amount of',
        ru: 'Сохранить и сбросить накопленное для',
    },
    'Se guardarán los cambios, el acumulado volverá a la base de reinicio y se recalculará el importe de disparo.': {
        pt: 'As alterações serão salvas, o acumulado voltará à base de reinício e o valor de disparo será recalculado.',
        en: 'Changes will be saved, the accumulated amount returns to the reset base and the trigger amount is recalculated.',
        ru: 'Изменения будут сохранены, накопленное вернётся к базе сброса, сумма срабатывания пересчитается.',
    },
    'Pozo guardado y acumulado reiniciado': {
        pt: 'Poço salvo e acumulado reiniciado',
        en: 'Pot saved and accumulated amount reset',
        ru: 'Фонд сохранён, накопленное сброшено',
    },
    'Esta acción no se puede deshacer.': {
        pt: 'Esta ação não pode ser desfeita.',
        en: 'This action cannot be undone.',
        ru: 'Это действие нельзя отменить.',
    },
    // ── pozo acumulado — apartados y ayudas del modal ────────────────────────
    'Nombre, grupo y nivel': { pt: 'Nome, grupo e nível', en: 'Name, group and level', ru: 'Имя, группа и уровень' },
    Economía: { pt: 'Economia', en: 'Economics', ru: 'Экономика' },
    'Base y disparo': { pt: 'Base e disparo', en: 'Base and trigger', ru: 'База и срабатывание' },
    'Ciclo y reserva': { pt: 'Ciclo e reserva', en: 'Cycle and reserve', ru: 'Цикл и резерв' },
    'Reparto del aporte': { pt: 'Divisão da contribuição', en: 'Contribution split', ru: 'Распределение взноса' },
    Presentación: { pt: 'Apresentação', en: 'Presentation', ru: 'Представление' },
    'Lo que ve el jugador': { pt: 'O que o jogador vê', en: 'What the player sees', ru: 'Что видит игрок' },
    'Uso y disponibilidad': {
        pt: 'Uso e disponibilidade',
        en: 'Usage and availability',
        ru: 'Использование и доступность',
    },
    'Para qué se usa este pozo': {
        pt: 'Para que serve este poço',
        en: 'What this pot is used for',
        ru: 'Для чего этот фонд',
    },
    'Junta los cuatro pozos de una colección para elegirlos de una vez. Es solo una etiqueta: no mueve dinero.': {
        pt: 'Junta os quatro poços de uma coleção para escolhê-los de uma vez. É apenas um rótulo: não move dinheiro.',
        en: 'Groups the four pots of a collection to pick them together. It is only a label: it moves no money.',
        ru: 'Объединяет четыре фонда коллекции для выбора сразу. Это только метка: деньги не двигает.',
    },
    'Crear los cuatro pozos acumulados de este grupo': {
        pt: 'Criar os quatro poços acumulados deste grupo',
        en: 'Create the four accumulated pots of this group',
        ru: 'Создать четыре накопительных фонда этой группы',
    },
    'Sin nivel (configuración anterior)': {
        pt: 'Sem nível (configuração anterior)',
        en: 'No level (previous setup)',
        ru: 'Без уровня (прежняя конфигурация)',
    },
    'Grand, Major, Minor y Mini son los cuatro niveles de una colección. Cada pozo es exactamente uno; Mini no sobra ni es un quinto elemento.':
        {
            pt: 'Grand, Major, Minor e Mini são os quatro níveis de uma coleção. Cada poço é exatamente um; Mini não sobra nem é um quinto elemento.',
            en: 'Grand, Major, Minor and Mini are the four levels of a collection. Each pot is exactly one; Mini is neither spare nor a fifth item.',
            ru: 'Grand, Major, Minor и Mini — четыре уровня коллекции. Каждый фонд — ровно один; Mini не лишний и не пятый элемент.',
        },
    Ámbito: { pt: 'Âmbito', en: 'Scope', ru: 'Область' },
    'Quién es el propietario. Dos grupos con el mismo nombre en ámbitos distintos son grupos distintos.': {
        pt: 'Quem é o proprietário. Dois grupos com o mesmo nome em âmbitos diferentes são grupos diferentes.',
        en: 'Who the owner is. Two groups with the same name in different scopes are different groups.',
        ru: 'Кто владелец. Две группы с одинаковым именем в разных областях — разные группы.',
    },
    'Se van a crear estos cuatro pozos acumulados': {
        pt: 'Serão criados estes quatro poços acumulados',
        en: 'These four accumulated pots will be created',
        ru: 'Будут созданы эти четыре накопительных фонда',
    },
    'Quedan disponibles para elegirlos, con la base económica de abajo. No se financian y no activan ningún producto.':
        {
            pt: 'Ficam disponíveis para serem escolhidos, com a base econômica abaixo. Não são financiados e não ativam nenhum produto.',
            en: 'They remain available to pick, with the economics below. They are not funded and activate no product.',
            ru: 'Остаются доступными для выбора с параметрами ниже. Не финансируются и не активируют продукты.',
        },
    'Base de reinicio': { pt: 'Base de reinício', en: 'Reset base', ru: 'База сброса' },
    'Importe al que vuelve el pozo después de pagarse.': {
        pt: 'Valor ao qual o poço volta depois de ser pago.',
        en: 'Amount the pot returns to after paying out.',
        ru: 'Сумма, к которой фонд возвращается после выплаты.',
    },
    'Porcentaje de cada apuesta que va a este pozo.': {
        pt: 'Porcentagem de cada aposta que vai para este poço.',
        en: 'Percentage of each bet that goes to this pot.',
        ru: 'Процент каждой ставки, идущий в этот фонд.',
    },
    'Rango de disparo': { pt: 'Faixa de disparo', en: 'Trigger range', ru: 'Диапазон срабатывания' },
    'Cómo se elige al ganador': {
        pt: 'Como o vencedor é escolhido',
        en: 'How the winner is chosen',
        ru: 'Как выбирается победитель',
    },
    'Cargar valores de referencia': {
        pt: 'Carregar valores de referência',
        en: 'Load reference values',
        ru: 'Загрузить эталонные значения',
    },
    'Rellena base, rango, contribución y reparto con la configuración aprobada para el nivel elegido. Solo cambia el formulario: nada se guarda hasta pulsar Guardar.':
        {
            pt: 'Preenche base, faixa, contribuição e divisão com a configuração aprovada para o nível escolhido. Altera apenas o formulário: nada é salvo até clicar em Salvar.',
            en: 'Fills base, range, contribution and split with the approved setup for the chosen level. It only changes the form: nothing is saved until you press Save.',
            ru: 'Заполняет базу, диапазон, взнос и распределение утверждённой конфигурацией уровня. Меняет только форму: ничего не сохраняется до нажатия «Сохранить».',
        },
    'Conservar fracciones de céntimo': {
        pt: 'Conservar frações de centavo',
        en: 'Keep cent fractions',
        ru: 'Сохранять доли копейки',
    },
    'Parte reservada para financiar el siguiente ciclo': {
        pt: 'Parte reservada para financiar o próximo ciclo',
        en: 'Share reserved to fund the next cycle',
        ru: 'Доля в резерве для следующего цикла',
    },
    'Distribución del umbral': {
        pt: 'Distribuição do limiar',
        en: 'Threshold distribution',
        ru: 'Распределение порога',
    },
    'Pareja en todo el rango': {
        pt: 'Uniforme em toda a faixa',
        en: 'Even across the range',
        ru: 'Равномерно по диапазону',
    },
    'Tendencia hacia importes mayores': {
        pt: 'Tendência para valores maiores',
        en: 'Leaning towards larger amounts',
        ru: 'Смещение к большим суммам',
    },
    'Fuerza de la tendencia': { pt: 'Força da tendência', en: 'Strength of the lean', ru: 'Сила смещения' },
    '1 = sin tendencia.': { pt: '1 = sem tendência.', en: '1 = no lean.', ru: '1 = без смещения.' },
    'Reserva actual': { pt: 'Reserva atual', en: 'Current reserve', ru: 'Текущий резерв' },
    'Excedente actual': { pt: 'Excedente atual', en: 'Current surplus', ru: 'Текущий излишек' },
    'Tema de animación': { pt: 'Tema de animação', en: 'Animation theme', ru: 'Тема анимации' },
    'Estilo visual de la animación cuando el pozo se paga.': {
        pt: 'Estilo visual da animação quando o poço é pago.',
        en: 'Visual style of the animation when the pot pays out.',
        ru: 'Визуальный стиль анимации при выплате фонда.',
    },
    'Título visible': { pt: 'Título visível', en: 'Display title', ru: 'Видимый заголовок' },
    'Ej: POZO MAYOR': { pt: 'Ex: POÇO MAIOR', en: 'E.g. MAJOR POT', ru: 'Напр.: ГЛАВНЫЙ ФОНД' },
    'Lo que se muestra en pantalla. Si se deja vacío, se usa el nombre.': {
        pt: 'O que aparece na tela. Se ficar vazio, usa o nome.',
        en: 'What is shown on screen. If left empty, the name is used.',
        ru: 'Что показывается на экране. Если пусто, используется имя.',
    },
    'Disponible significa que se puede elegir. No significa que esté financiado, ni que haya un producto activo usándolo.':
        {
            pt: 'Disponível significa que pode ser escolhido. Não significa que esteja financiado nem que haja um produto ativo usando-o.',
            en: 'Available means it can be picked. It does not mean it is funded, nor that an active product uses it.',
            ru: 'Доступен означает, что его можно выбрать. Это не значит, что он профинансирован или используется активным продуктом.',
        },
    'Zona de peligro': { pt: 'Zona de perigo', en: 'Danger zone', ru: 'Опасная зона' },
    'Estas acciones afectan al dinero acumulado o retiran el pozo de circulación.': {
        pt: 'Estas ações afetam o dinheiro acumulado ou retiram o poço de circulação.',
        en: 'These actions affect the accumulated money or take the pot out of circulation.',
        ru: 'Эти действия затрагивают накопленные деньги или выводят фонд из обращения.',
    },
    'Guardar y reiniciar el acumulado': {
        pt: 'Salvar e reiniciar o acumulado',
        en: 'Save and reset the accumulated amount',
        ru: 'Сохранить и сбросить накопленное',
    },
    'Sigue operando igual. Se puede editar sin convertirlo.': {
        pt: 'Continua operando igual. Pode ser editado sem convertê-lo.',
        en: 'It keeps operating the same. It can be edited without converting it.',
        ru: 'Работает как прежде. Можно редактировать без преобразования.',
    },
    'Este pozo se creó antes de los cuatro niveles: no tiene nivel asignado y todo su aporte va al importe visible.': {
        pt: 'Este poço foi criado antes dos quatro níveis: não tem nível atribuído e toda a sua contribuição vai para o valor visível.',
        en: 'This pot was created before the four levels: it has no level assigned and its whole contribution goes to the visible amount.',
        ru: 'Этот фонд создан до четырёх уровней: уровень не назначен, весь взнос идёт в видимую сумму.',
    },
    'Abrirlo, editar su nombre o guardar no lo convierte. Conserva su id, su saldo, su base, su historial y sus suscripciones.':
        {
            pt: 'Abri-lo, editar seu nome ou salvar não o converte. Mantém seu id, seu saldo, sua base, seu histórico e suas assinaturas.',
            en: 'Opening it, editing its name or saving does not convert it. It keeps its id, balance, base, history and subscriptions.',
            ru: 'Открытие, изменение имени или сохранение не преобразуют его. Сохраняются id, баланс, база, история и подписки.',
        },
    'Completar la configuración de niveles': {
        pt: 'Completar a configuração de níveis',
        en: 'Complete the level setup',
        ru: 'Завершить настройку уровней',
    },
};
